module.exports = __webpack_public_path__ + "img/logo.a33fd2b8.png";